import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllMF } from "../../redux/mf/mfSlice";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Pagination,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { colors } from "../../constants/colors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { formatAmount, toCamelCase, truncateText } from "../../utils";
import { InfoOutlined, MoreVert, Search } from "@mui/icons-material";

const MFTableRow = ({ row }: { row: any }) => {
  const [isinWishilist, setIsinWishilist] = useState<any>();
  const [anchorMD, setAnchorMD] = React.useState<null | HTMLElement>(null);

  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLElement | null>(
    null
  );
  const isPopoverOpen = Boolean(popoverAnchorEl);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setPopoverAnchorEl(event.currentTarget); // Correct event type
  };

  const handlePopoverClose = () => {
    setPopoverAnchorEl(null); // Reset
  };
  const StringRemover = (title: string) => {
    let titleLength = title.length;
    return titleLength > 6 ? title.slice(0, titleLength - 6) : title;
  };

  const modalMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    isinWishilist: number,
    id: number
  ) => {
    setAnchorMD(event.currentTarget);
    let data = { status: isinWishilist, id: id };
    setIsinWishilist(data);
  };
  return (
    <TableRow
      key={row.id}
      sx={{ borderRadius: "50px!important" }}
      className=" border-[1px] bg-white border-lightGrey hover:border-[1px] hover:bg-lightBg cursor-pointer"
    >
      <TableCell
        component="th"
        scope="row"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        <a
          href={`/mf-details/${row.isin}/${row.id}`}
          target="_self"
          style={{
            textDecoration: "none",
            color: "inherit",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {toCamelCase(row.schemeName)}
        </a>
        {/* <div className="flex items-center gap-x-2 cursor-pointer">
      <span>
        {row.schemeName}
      </span>
    </div> */}
      </TableCell>
      <TableCell
        align="left"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        {row.isin}
      </TableCell>
      <TableCell
        align="left"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        {StringRemover(row.fundSize)}
      </TableCell>
      <TableCell
        align="left"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        {formatAmount(row.currentNAV)}
      </TableCell>
      <TableCell
        align="left"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        {row.returnRate1Yrs
          ? `${Number(row.returnRate1Yrs).toFixed(2)}  % `
          : "-"}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        {row.expenseRatio ? `${Number(row.expenseRatio).toFixed(2)} %` : "-"}
      </TableCell>

      <TableCell
        align="right"
        sx={{
          minWidth: 200,
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        <Tooltip title="" arrow>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100px",
            }}
          >
            {truncateText(row.exitLoad, 15)}
          </span>
        </Tooltip>

        <IconButton
          onClick={handlePopoverOpen}
          size="small"
          sx={{ padding: "0 5px" }}
        >
          <InfoOutlined fontSize="small" />
        </IconButton>

        <Popover
          open={isPopoverOpen}
          anchorEl={popoverAnchorEl}
          onClose={handlePopoverClose}
          disableScrollLock={true}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <Box p={2} sx={{ maxWidth: 300 }}>
            {row.exitLoad}
          </Box>
        </Popover>
      </TableCell>

      {/* <TableCell align="center" sx={{ border: "none",fontSize:{
              xs:"12px",
              sm:"16px"
            } }}>
    {row.mfRank}
  </TableCell> */}
      <TableCell
        align="left"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        {row.riskLevel}
      </TableCell>
      {/* <TableCell
        align="right"
        sx={{
          border: "none",
          fontSize: {
            xs: "12px",
            sm: "16px",
          },
        }}
      >
        <IconButton
          onClick={(e) => {
            modalMenuClick(e, row?.isInWishlist, row?.id);
          }}
        >
          <MoreVert />
        </IconButton>
      </TableCell> */}
    </TableRow>
  );
};

const MFListing = () => {
  const dispatch = useDispatch<any>();
  const [loader, setLoader] = React.useState(false);
  const [inputData, setInputData] = useState<any>({
    pageIndex: 1,
    pageSize: 100,
    query: "",
    type: [],
    subType: [],
    tenure: "",
  });
  const [page, setPage] = useState(1);
  const [countOFPages, seCountOFPages] = useState(1);

  const [MFData, setMFData] = useState<any[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: string | null;
  }>({
    key: "schemeName", // Set the default key to "assetName" or any other column you want
    direction: "ascending", // Set the default direction to ascending
  });
  //Fetch MF Data from Get All fund list API
  const fetchData = async () => {
    setLoader(true); // Start loading
    try {
      const response = await dispatch(getAllMF(inputData));

      if (response) {
        let mfList = response?.payload?.mfList || [];

        // Filter based on query for schemeName, schemeType, schemePlan, and riskLevel
        if (inputData.query) {
          const query = inputData.query.toLowerCase();
          mfList = mfList?.filter(
            (mf: any) =>
              mf.schemeName.toLowerCase()?.includes(query) ||
              mf.schemeType.toLowerCase() === query ||
              mf.schemePlan.toLowerCase()?.includes(query) ||
              mf.riskLevel.toLowerCase() === query
          );
        }
        setMFData(mfList);
        // setTotalFound(mfList?.length);
        seCountOFPages(response?.payload?.totalPages || 0);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoader(false); // End loading
      //   setfilterButton(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    fetchData();
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [inputData.query]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
    setInputData({ ...inputData, pageIndex: value });
    fetchData();
  };

  useEffect(() => {
    if (inputData.query !== "") {
      fetchData();
    }
  }, [inputData.query]);

  const getSortedData = useCallback(() => {
    if (!sortConfig.key) return MFData;
    const sortedData = [...MFData];

    const compareStrings = (a: string, b: string) => {
      if (a < b) return sortConfig.direction === "ascending" ? -1 : 1;
      if (a > b) return sortConfig.direction === "ascending" ? 1 : -1;
      return 0;
    };

    const compareNumbers = (a: any, b: any) => {
      // Convert both to floats
      a = parseFloat(a?.toString());
      b = parseFloat(b?.toString());

      return sortConfig.direction === "ascending" ? a - b : b - a;
    };

    const compareDates = (a: string, b: string) => {
      if (!a || !b) return 0; // You can handle this differently based on requirements
      const [dayA, monthA, yearA] = a.split("-").map(Number);
      const [dayB, monthB, yearB] = b.split("-").map(Number);

      if (
        isNaN(dayA) ||
        isNaN(monthA) ||
        isNaN(yearA) ||
        isNaN(dayB) ||
        isNaN(monthB) ||
        isNaN(yearB)
      ) {
        return 0;
      }

      const dateA = new Date(yearA, monthA - 1, dayA);
      const dateB = new Date(yearB, monthB - 1, dayB);

      return sortConfig.direction === "ascending"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    };

    sortedData.sort((a, b) => {
      const schemeA = a.schemes?.[0] || {};
      const schemeB = b.schemes?.[0] || {};

      switch (sortConfig.key) {
        case "schemeName":
          return compareStrings(
            a?.schemeName.toUpperCase(),
            b?.schemeName.toUpperCase()
          );
        case "inceptionDate":
          return compareDates(schemeA.inceptionDate, schemeB.inceptionDate);
        case "fundSize":
          return compareStrings(
            a.fundSize.toUpperCase(),
            b.fundSize.toUpperCase()
          );
        case "currentNAV":
          return compareNumbers(a.currentNAV, b.currentNAV); // Directly access currentNAV
        case "returnRate1Yrs":
          return compareNumbers(a.returnRate1Yrs, b.returnRate1Yrs); // Directly access returnRate1Yrs
        case "expenseRatio":
          return compareStrings(
            a.expenseRatio.toUpperCase(),
            b.expenseRatio.toUpperCase()
          );
        case "riskLevel":
          return compareStrings(
            a.riskLevel.toUpperCase(),
            b.riskLevel.toUpperCase()
          );
        default:
          return 0;
      }
    });

    return sortedData;
  }, [MFData, sortConfig]);

  const handleSort = (key: string) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = getSortedData();

  return (
    <div
      className="min-h-screen bg-lightBg py-8"
      style={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "20px",
      }}
    >
      <div className="max-w-[1440px] mx-auto">
        <Box
          width="90%"
          mb={2}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="text-2xl font-bold text-primary font-inter">
            Mutual Funds
          </h3>
        </Box>
        <div className="py-4 mb-3">
          <TextField
            className="w-full"
            sx={{ maxWidth: "500px" }}
            onChange={(e) => {
              setInputData({ ...inputData, query: e.target.value });
            }}
            placeholder="Search mutual funds"
            hiddenLabel
            id="filled-hidden-label-small"
            size="small"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {/* Mf List Table */}
          <TableContainer
            component="div"
            style={{
              width: "100%",
              overflowX: "auto",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
          >
            <Table>
              <TableHead
                sx={{
                  backgroundColor: colors.white,
                  marginBottom: "50px",
                  border: "none",
                }}
              >
                <TableRow sx={{ border: "none" }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                  >
                    <div className={`flex items-center w-auto justify-start`}>
                      Asset Name
                      <div className="flex flex-col items-center justify-center w-10 h-2 ml-2">
                        <KeyboardArrowUpIcon
                          className="w-2 mb-[-10px] cursor-pointer"
                          onClick={() => handleSort("schemeName")}
                        />
                        <KeyboardArrowDownIcon
                          className="cursor-pointer"
                          onClick={() => handleSort("schemeName")}
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                  >
                    ISIN
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="left"
                  >
                    <div className={`flex items-center w-auto justify-center`}>
                      Month End AUM (in Cr)
                      <div className="flex flex-col items-center justify-center w-10 h-2 ml-2">
                        <KeyboardArrowUpIcon
                          className="w-2 mb-[-10px] cursor-pointer"
                          onClick={() => handleSort("fundSize")}
                        />
                        <KeyboardArrowDownIcon
                          className="cursor-pointer"
                          onClick={() => handleSort("fundSize")}
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="left"
                  >
                    <div className={`flex items-center w-auto justify-center`}>
                      Current NAV
                      <div className="flex flex-col items-center justify-center w-10 h-2 ml-2">
                        <KeyboardArrowUpIcon
                          className="w-2 mb-[-10px] cursor-pointer"
                          onClick={() => handleSort("currentNAV")}
                        />
                        <KeyboardArrowDownIcon
                          className="cursor-pointer"
                          onClick={() => handleSort("currentNAV")}
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="left"
                  >
                    <div className={`flex items-center w-auto justify-center`}>
                      CAGR (1Y)
                      <div className="flex flex-col items-center justify-center w-10 h-2 ml-2">
                        <KeyboardArrowUpIcon
                          className="w-2 mb-[-10px] cursor-pointer"
                          onClick={() => handleSort("returnRate1Yrs")}
                        />
                        <KeyboardArrowDownIcon
                          className="cursor-pointer"
                          onClick={() => handleSort("returnRate1Yrs")}
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="left"
                  >
                    <div className={`flex items-center w-auto justify-center`}>
                      Expense Ratio
                      <div className="flex flex-col items-center justify-center w-10 h-2 ml-2">
                        <KeyboardArrowUpIcon
                          className="w-2 mb-[-10px] cursor-pointer"
                          onClick={() => handleSort("expenseRatio")}
                        />
                        <KeyboardArrowDownIcon
                          className="cursor-pointer"
                          onClick={() => handleSort("expenseRatio")}
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="center"
                  >
                    Exit Load
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="left"
                  >
                    <div className={`flex items-center w-auto justify-center`}>
                      Risk Level
                      <div className="flex flex-col items-center justify-center w-10 h-2 ml-2">
                        <KeyboardArrowUpIcon
                          className="w-2 mb-[-10px] cursor-pointer"
                          onClick={() => handleSort("riskLevel")}
                        />
                        <KeyboardArrowDownIcon
                          className="cursor-pointer"
                          onClick={() => handleSort("riskLevel")}
                        />
                      </div>
                    </div>
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      fontWeight: 600,
                      color: colors.primary,
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                    }}
                    align="left"
                  >
                    Action
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row) => (
                  <MFTableRow key={row.id} row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="flex justify-center items-center my-4">
          <Pagination
            shape="rounded"
            count={countOFPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </div>
      </div>
    </div>
  );
};

export default MFListing;
